// extracted by mini-css-extract-plugin
var _1 = "DepositFormStyle-module__blocked___CQBkn";
var _2 = "DepositFormStyle-module__deposit-form___j8Lr6";
var _3 = "DepositFormStyle-module__deposit-form___j8Lr6";
var _4 = "DepositFormStyle-module__usdtToFiatAgreement___vQjb4";
export { _1 as "blocked", _2 as "deposit-form", _3 as "depositForm", _4 as "usdtToFiatAgreement" }
